<template>
    <b-modal
        id="custom-editor-file-custom-editor-file-upload-modal"
        v-model="modal"
        ref="custom-editor-file-custom-editor-file-upload-modal"
        :title="$t('common.upload')"
        :ok-title="$t('common.upload')"
        :cancel-title="$t('common.cancel')"
        cancel-variant="outline-primary"
        :ok-disabled="disabled"
        modal-class="apprentice-default-modal"
        @close="onClose()"
        @ok="onOk()">
        <div class="error">
            <b-alert
                show
                variant="danger">
                {{
                    $t(
                        'group.internship.make_sure_no_one_is_working_in_the_editor_if_a_file_is_uploaded_while_someone_is_in_the_editor_work_may_be_lost',
                    )
                }}
            </b-alert>
        </div>

        <div class="file-upload">
            <b-form-group>
                <b-form-file
                    class="apprentice-file-upload"
                    v-model="file"
                    name="file"
                    :placeholder="$t('upload.placeholder_word')"
                    :drop-placeholder="$t('upload.placeholder_drop_word')"
                    :browse-text="$t('upload.choose_file')"
                    accept=".docx">
                </b-form-file>
            </b-form-group>
        </div>
    </b-modal>
</template>

<script>
export default {
    name: 'design-2021-group-show-upload-custom-editor-file-modal-component',
    props: ['id'],
    data() {
        return {
            file: null,
            modal: false,
            groupCustomEditorFileId: null,
        };
    },
    methods: {
        show(groupCustomEditorFileId) {
            this.groupCustomEditorFileId = groupCustomEditorFileId;
            this.modal = true;
        },
        onOk() {
            let formData = new FormData();
            formData.append('file', this.file);
            const headers = { 'Content-Type': 'multipart/form-data' };

            this.alert.saving(this.$t('common.upload'), this.$t('upload.file_being_uploaded'));

            this.axios
                .post(this.routes.groupUploadCustomEditorFile(this.id, this.groupCustomEditorFileId), formData, {
                    headers: headers,
                })
                .then(
                    (response) => {
                        this.$emit('fileUploaded', response.data);
                        this.alert.success();
                    },
                    (error) => {
                        this.alert.ajaxError(error);
                    },
                );
        },
        onClose() {
            this.file = null;
        },
    },
    computed: {
        disabled() {
            return !this.file;
        },
    },
    created() {
        this.csrfToken = document.querySelector('meta[name="csrf-token"]').content;
    },
};
</script>

<style scoped lang="scss">
.error {
    margin-top: 0;
}

.file-upload {
    margin-bottom: map-get($grid-gutter-spacing, 'twenty-one');
}
</style>
